import Link from 'next/link'
import Head from 'next/head'
import { Container } from './Container'
import Header from './Header'
import { classNames, ParseWordPressHTML } from '../helpers/utils'
import { legalPageLinks, sanitizeLegalContent } from '../helpers/legalPages'

export default function LegalPage({
    contentClassName = 'legal-page-terms',
    currentPath,
    data,
    meta,
    metaTitle,
    pendingMessage,
    title,
}) {
    const content = data?.content?.rendered
        ? sanitizeLegalContent(data.content.rendered)
        : ''

    return (
        <div>
            <Head>
                <link
                    href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700"
                    rel="stylesheet"
                />
            </Head>
            <Header meta={meta} metaTitle={metaTitle} hideTitle={true} />

            <Container>
                <div className="mx-auto w-full max-w-4xl">
                    <div className="flex flex-col gap-8">
                        <div className="border-b border-gray-200 pb-6">
                            <h1 className="text-4xl font-semibold tracking-tight text-[#1f2937]">
                                {title}
                            </h1>
                            <nav
                                className="mt-4 flex flex-wrap gap-3"
                                aria-label="Legal pages">
                                {legalPageLinks.map((link) => {
                                    const isActive = currentPath === link.href

                                    return (
                                        <Link
                                            key={link.href}
                                            href={link.href}
                                            passHref>
                                            <a
                                                aria-current={
                                                    isActive
                                                        ? 'page'
                                                        : undefined
                                                }
                                                className={classNames(
                                                    'rounded-full border px-4 py-2 text-sm font-medium transition-colors',
                                                    isActive
                                                        ? 'border-[#ef6c2a] bg-[#ef6c2a] text-white'
                                                        : 'border-gray-300 text-gray-700 hover:border-[#ef6c2a] hover:text-[#ef6c2a]',
                                                )}>
                                                {link.label}
                                            </a>
                                        </Link>
                                    )
                                })}
                            </nav>
                        </div>

                        <div className={contentClassName}>
                            {pendingMessage ? (
                                <div className="rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4 text-[15px] leading-7 text-amber-900">
                                    {pendingMessage}
                                </div>
                            ) : (
                                <ParseWordPressHTML className="legal-page-terms-content">
                                    {content}
                                </ParseWordPressHTML>
                            )}
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    )
}
